<template>
    <div>
        <vs-dialog prevent-close v-model="active">
            <template #header>
                <h4 class="not-margin">
                    {{existente.status_busqueda}}
                </h4> 
            </template>


            <div class="con-form">
                <div class="form-group">
                    <h5>¿Esta seguro de asociar al alumno con la siguiente información?</h5>
                    <p class="mb-0">Alumno: {{existente.nombre_alumno}}<strong></strong></p>
                    <p class="mb-0">Matrícula: {{existente.matricula}}<strong></strong></p>
                    <p class="mb-0">CURP: {{existente.curp}}<strong></strong></p>
                    <p class="mb-0">Fecha de nacimiento: {{existente.fecha_nacimiento}}<strong></strong></p>
                </div>
            </div>

            <template #footer>
                <div class="footer-dialog d-flex">
                    <vs-button danger block @click="active = false" style="width: 30%;">
                    Cancelar
                    </vs-button>
                    <vs-button success class="ml-auto" block @click="postAvanzar()" style="width: 30%;">
                    Aceptar
                    </vs-button>
                </div>
            </template>
        </vs-dialog>
    </div>
</template>

<script>
import landing from '../../../../../api/requests/landing'
export default {
    props:[
      'value',
      'existente',
      'idPersona'
    ],
    data(){
        return{
            active: false,
            curp: '',
            fecha_nacimiento: '',
            invalidoCurp: false,
            errorFields:[]
        }
    },
    methods:{
        
        async postAvanzar(){
            const loading = this.$vs.loading()
            try{
                const formData = new FormData()
                formData.append('curp', this.existente.curp)
                formData.append('fecha_nacimiento', this.existente.fecha_nacimiento)
                formData.append('confirmacion_vinculacion', 'confirmado')
                const response = await landing.postAvanzar(this.idPersona, formData)
                loading.close()
                this.$emit('refreshProcess')
                this.active = false
            }catch(error){
                loading.close()
                console.log(error)
            }
        },
    },
    watch: {
        value (val) {
            this.active = val
        },
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
    }
}
</script>